<template>
  <div id="app">
    <!-- <keep-alive> -->
        <router-view/>
    <!-- </keep-alive> -->
  </div>
</template>

<script>
// import VConsole from 'vconsole'
export default {
  name: 'App',
  created () {
    // this.vConsole = new VConsole()
  }
}
</script>

<style lang="scss">
body{
    width:100vw;
    height: 100vh;
    margin: 0;
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    font-size: 14px;
    line-height: 1.42857143;
    color: #333;
}
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50; */
  font-size: 14px;
  width: 100%;
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// examples/App.vue